import React, { useState, useEffect } from 'react'
import boardApprovalService from '../../../../../services/Internal/Reinstatement/PLS/boardApproval.service';
import YesNoRadioOption from '../../../../Shared/RadioButton/YesNoRadioOption'
import DocumentUpload from '../../../../Shared/Upload/DocumentUpload';
import * as dayjs from 'dayjs';
import { FaCheck, FaEdit, FaPlus, FaQuestion, FaSave, FaTimes, FaTrash } from 'react-icons/fa';
import { Button, Card, Row, Col, CardGroup, Accordion, Table } from 'react-bootstrap'
import { DatePicker, Form, InputPicker } from 'rsuite';
import Swal from 'sweetalert2'
import AddBoardMemberCommentModal from '../../../../Shared/Modal/AddBoardMemberCommentModal.jsx';
import boardCommentsService from '../../../../../services/Shared/boardComments.service.js';
import BoardAttachmentGrid from '../../../../Shared/Grid/BoardAttachmentGrid';
import TextArea from '../../../../Shared/GenericComponents/TextArea';

function BoardApproval(props) {
    const [refreshAttachments, setRefreshAttachments] = useState(0);
    const credentialTypeId = 5;
    const [hasLoaded, setHasLoaded] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({});
    const [approvals, setApprovals] = useState([...props.gridData.map((val) => {
        return {
            ...val,
            staffDecision: val.boardMemberDecision,
            dateSent: val.dateSent != null ? dayjs(val.dateSent).format('YYYY-MM-DD') : null,
            dateReceived: val.dateReceived != null ? new Date(val.dateReceived) : null
        }
    })])
    const decisionData = [
        { "label": "Approved", "value": { id: 1, boardMemberDecision: "Approved" } },
        { "label": "Declined", "value": { id: 2, boardMemberDecision: "Declined" } }];
    const [comments, setComments] = useState([]);

    useEffect(() => {
        setHasLoaded(false)
        const fetchData = async () => {
            const enrichedItems = await Promise.all(
                props.gridData.map(async (item) => {
                    return {
                        ...item,
                        staffDecision: item.boardMemberDecision,
                        dateSent: item.dateSent != null ? dayjs(item.dateSent).format('YYYY-MM-DD') : null,
                        dateReceived: item.dateReceived != null ? new Date(item.dateReceived) : null,
                    };
                })
            );
            boardCommentsService.getBoardComments(props.parentId, 2).then((responseComments) => {
                setComments(responseComments.data);
                setApprovals(enrichedItems);
                setHasLoaded(true)
            });
        }
        fetchData();
    }, [props.gridData])

    const formDataAppender = (passedKey, model, formData) => {
        for (let key in model) {
            if (typeof (model[key]) === 'object') {
                formDataAppender(`${passedKey}.${key}`, model[key], formData); // Recursive key for objects
            }
            else {
                if (passedKey)
                    formData.append(`${passedKey}.${key}`, model[key]);
                else
                    formData.append(`${key}`, model[key]);
            }
        }
    }
    const refreshComments = async () => {
        boardCommentsService.getBoardComments(props.parentId, 2).then((responseComments) => {
            setComments(responseComments.data);
        });
    }
    const openCommentModal = (comment) => {
        if (comment) {
            setModalData({ ...comment })
        }
        else {
            setModalData({
                id: 0,
                parentId: props.parentId,
                parentTypeId: 2,
                comment: ''
            });
        }
        setShowModal(true);
    }
    const deleteComment = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {

                boardCommentsService.deleteBoardComment(id).then((response) => {
                    if (response.status == 200) {
                        refreshComments();
                    }
                })
            }
        })
    }
    return <>
        <AddBoardMemberCommentModal
            modalData={modalData}
            show={showModal}
            onHide={() => { setModalData({}); setShowModal(false) }}
            refreshComments={refreshComments}
        />
        <Card className='mb-3'>
            <Card.Header><h6>Board/Staff Attachments</h6></Card.Header>
            <Card.Body>
                <DocumentUpload
                    isUserEditable={props.isUserEditable}
                    credentialTypeId={credentialTypeId}
                    sectionId={props.sectionId}
                    parentId={props.sectionDataId}
                    parentTypeId={8}
                    entityId={props.entityId}
                    fileUploadTitle={"Uploads/Documents"}
                    setRefreshAttachments={setRefreshAttachments}
                    refreshAttachments={refreshAttachments}
                />
                <hr />
                <Form.Group>
                    <Form.ControlLabel><b>Additional Comments</b></Form.ControlLabel>
                    <Form.Control
                        readOnly={!props.isUserEditable}
                        rows={5}
                        accepter={TextArea}
                        name="additionalComments" />
                </Form.Group>
                {props.isUserEditable && <Button className="float-end" onClick={props.openModal}><FaPlus /> Add Board Member</Button>}
            </Card.Body>
        </Card>
        <CardGroup>
            {
                hasLoaded && approvals.map((item) => {
                    const editClick = () => {
                        props.openModal(item)
                    }
                    const deleteClick = () => {
                        Swal.fire({
                            title: 'Are you sure?',
                            text: "You won't be able to revert this!",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes, delete it!'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                var formData = new FormData();
                                var dataToTransmit = {
                                    ...item,
                                    deleted: true,
                                }
                                formDataAppender('boardMemberResponse', dataToTransmit, formData);
                                boardApprovalService.postBoardResponse(formData).then((response) => {
                                    if (response.status == 200) {
                                        props.setGridData([...props.gridData.filter(x => x.id !== item.id)]);
                                    }
                                })
                            }
                        })
                    }
                    const saveClick = () => {
                        Swal.fire({
                            title: 'Are you sure?',
                            text: `You are about to save these changes and may not be able to revert them.`,
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Save'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                var formData = new FormData()
                                var dataToTransmit = {
                                    ...item,
                                    boardMemberDecision: item.staffDecision,
                                    dateSent: new Date(item.dateSent).toISOString(),
                                    dateReceived: item.dateReceived ? new Date(item.dateReceived).toISOString() : null
                                }
                                formDataAppender('boardMemberResponse', dataToTransmit, formData);
                                boardApprovalService.postBoardResponse(formData).then((response) => {
                                    if (response.data.boardMemberResponse.id) {
                                        let list = [...approvals];
                                        list[approvals.findIndex(x => x.id == response.data.boardMemberResponse.id)].boardMemberDecision = item.staffDecision;
                                        setApprovals([...list])
                                    }
                                })
                            }
                        })
                    }
                    return (
                        <Form formValue={item}
                            readOnly={!props.isUserEditable}
                            onChange={val => {
                                let list = [...approvals];
                                list[approvals.findIndex(x => x.id == val.id)] = val;
                                setApprovals([...list])
                            }}
                            fluid>
                            <Accordion eventKey={item.id} >
                                <Card className="mb-3 me-3" >
                                    <Accordion.Button as={Card.Header} eventKey={item.id} style={item.boardMemberDecision ? item.boardMemberDecision.id == 1 ? { backgroundColor: 'lightGreen' } : { backgroundColor: 'rgba(220, 20, 60, 0.5)' } : { backgroundColor: '#FAFAD2' }}>
                                        <div className='w-100 text-nowrap' >
                                            <Row>
                                                <Col>
                                                    <h6> {`${item?.boardMember?.firstName} ${item?.boardMember?.middleName} ${item?.boardMember?.lastName}, ${item?.boardMember?.credentialSuffix}`}</h6>
                                                </Col>
                                                <Col style={{ textAlign: 'right', justifyContent: 'end', marginRight: '1em' }}>
                                                    {item.boardMemberDecision ?
                                                        <>
                                                            {item.boardMemberDecision.id == 1 &&
                                                                <FaCheck style={{ color: 'green', fontSize: '24' }} />
                                                            }
                                                            {item.boardMemberDecision.id == 2 &&
                                                                <FaTimes style={{ color: '#EB0000', fontSize: '24' }} />}
                                                        </> :
                                                        <FaQuestion style={{ color: 'gold', fontSize: '24' }} />
                                                    }
                                                </Col>
                                            </Row>
                                        </div>
                                    </Accordion.Button>
                                    <Accordion.Body eventKey={item.id}><>
                                        <Card.Body>
                                            <BoardAttachmentGrid
                                                attachmentParentTypeId={8}
                                                entityId={props.entityId}
                                                credentialOrAppTypeId={credentialTypeId}
                                                isApp={false}
                                                attachmentSectionId={props.sectionDataId}
                                                refreshAttachments={refreshAttachments}
                                            />
                                            <hr />
                                            <Row style={{ marginTop: '1em' }}>
                                                <Col>
                                                    <Form.ControlLabel>
                                                        <strong>
                                                            Date Sent
                                                        </strong>
                                                    </Form.ControlLabel>
                                                    <Form.Control disabled type="date" name="dateSent" block />
                                                </Col>
                                                <Col>
                                                    <Form.ControlLabel>
                                                        <strong>
                                                            Decision Date
                                                        </strong>
                                                    </Form.ControlLabel>
                                                    <Form.Control accepter={DatePicker} name="dateReceived" block value={item.dateReceived} />
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        {props.isUserEditable &&
                                            <Card.Footer>
                                                <Row>
                                                    <Col>
                                                        <Form.Control
                                                            block
                                                            name="staffDecision"
                                                            placeholder="Decision..."
                                                            accepter={InputPicker}
                                                            data={decisionData} />
                                                    </Col>
                                                    <Col style={{ textAlign: "right" }}>

                                                        <Button variant="light" title="Save" onClick={saveClick}><FaSave /></Button>
                                                        <Button variant="light" title="Delete" onClick={deleteClick}><FaTrash /></Button>
                                                        <Button variant="light" title="Edit" onClick={editClick}><FaEdit /></Button>
                                                    </Col>
                                                </Row>
                                            </Card.Footer>}
                                    </>
                                    </Accordion.Body>
                                </Card>
                            </Accordion>
                        </Form>
                    );
                })
            }
        </CardGroup>
        {hasLoaded &&
            <Card className='mb-3'>
                <Card.Header>
                    <Row>
                        <Col style={{ alignItems: "center", display: 'flex' }}>
                            <h5>Comments</h5>
                        </Col>
                        {props.isUserEditable &&
                            <Col style={{ textAlign: 'right' }}>
                                <Button variant="primary" title="Add Comment" onClick={() => { openCommentModal() }}>Add Comment</Button>
                            </Col>
                        }
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Table hover className={"table-bordered"}>
                        <thead>
                            <tr>
                                <th>Comment</th>
                                <th>From</th>
                                <th>Date/Time</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {comments.length ? comments.map((item, i) => {
                                return (
                                    <tr key={item.id} id={i}>
                                        <td>{item.comment}</td>
                                        <td>{item.userName}</td>
                                        <td>{`${new Date(item.dateCrte).toLocaleDateString()} ${new Date(item.dateCrte).toLocaleTimeString()}`}</td>
                                        <td>
                                            {item.isEditable && <>
                                                <Button className="me-2" onClick={() => { openCommentModal(item) }} ><FaEdit /></Button><Button variant="danger" onClick={() => { deleteComment(item.id) }}><FaTrash /></Button></>
                                            }
                                        </td>
                                    </tr>
                                )
                            }) :
                                <tr>
                                    <td style={{ textAlign: 'center' }} colSpan={4}><h5>No Comments</h5></td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        }
        <Card>
            <Card.Header>
                <h6>Board/Staff Checklist</h6>
            </Card.Header>
            <Card.Body>
                <p>Exams verified in Applicants MyNCEES Account (FS, PLS, State Specific (Louisiana Laws))?</p>
                <YesNoRadioOption isReadOnly={!props.isUserEditable} radioName="examsVerifiedInMyNcees" />
                <p>Board approval?</p>
                <YesNoRadioOption isReadOnly={!props.isUserEditable} radioName="boardApproval" />
            </Card.Body>
        </Card>
    </>;
}

export default BoardApproval;